import { useAuthStore } from "@shared/src/stores/useAuthStore";
import { useQuery } from "@tanstack/react-query";
import { KYC_STATUS_QUERY_KEY } from "@shared/src/lib/queryKeys";
import { settingsService } from "@shared/src/services/settings.service";
import { KYCStatus } from "@sdk/shared/types/settings.types";
import { countriesKYC } from "@shared/src/lib/countries";

async function getKycStatus(jwt: string): Promise<KYCStatus | null> {
  try {
    const { data: account } = await settingsService.getAccount(jwt);

    const submitedKycs = account?.addresses.find(ad => ad.kycManual?.length > 0)?.kycManual;
    const latestKYC = submitedKycs?.sort(
      (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
    )[0];
    const status = latestKYC?.kycValidatedAt
      ? "approved"
      : latestKYC?.kycRejectedAt
      ? "rejected"
      : latestKYC
      ? "pending"
      : null;

    return (
      status && {
        country: latestKYC?.country || "",
        currency: countriesKYC[0][latestKYC?.country as keyof (typeof countriesKYC)[0]]?.currency || "",
        kycStatus: status,
        updatedAt: latestKYC?.updatedAt || "",
        fullName: `${latestKYC?.firstName} ${latestKYC?.otherName} ${latestKYC?.lastName}`,
      }
    );
  } catch (e) {
    return null;
  }
}
export const useKycStatus = () => {
  const activeAccount = useAuthStore(state => state.activeAccount);

  const { data: kycStatusDoc, isLoading } = useQuery({
    queryKey: KYC_STATUS_QUERY_KEY(activeAccount?.id || 0),
    queryFn: async () => {
      if (!activeAccount) return null;
      try {
        const statusDoc = await getKycStatus(activeAccount.jwt);

        return statusDoc;
      } catch (e) {
        return null;
      }
    },
    enabled: !!activeAccount,
  });

  return {
    ...kycStatusDoc,
    isLoading,
  };
};
